import React from "react";
import { StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";
import { useTranslation } from "react-i18next";
import { File } from "../types";
import FileListItem from "./FileListItem";

interface RecentFilesSectionProps {
  files: File[];
  onFileOpen: (file: File) => void;
  onFileDownload: (file: File) => void;
  onFileShare: (file: File) => void;
  onFileRename: (file: File) => void;
  onFileDelete: (file: File) => void;
  onFileViewDetails: (file: File) => void;
}

export default function RecentFilesSection({
  files,
  onFileOpen,
  onFileDownload,
  onFileShare,
  onFileRename,
  onFileDelete,
  onFileViewDetails,
}: RecentFilesSectionProps) {
  const { t } = useTranslation();

  return (
    <View style={styles.section}>
      <View style={styles.sectionHeader}>
        <Text variant="labelLarge" style={styles.sectionTitle}>
          {t("Recent Files")}
        </Text>
      </View>

      <View style={styles.filesList}>
        {files.map((file) => (
          <FileListItem
            key={file.id}
            file={file}
            onOpen={onFileOpen}
            onDownload={onFileDownload}
            onShare={onFileShare}
            onRename={onFileRename}
            onDelete={onFileDelete}
            onViewDetails={onFileViewDetails}
          />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  section: {
    marginTop: 8,
    paddingHorizontal: 16,
  },
  sectionHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
  },
  sectionTitle: {
    fontWeight: "600",
    opacity: 0.6,
  },
  filesList: {
    gap: 4,
  },
});
